window.enableGui = function () {
	$('#guidisable').css({'visibility': 'hidden', 'display': 'none'});
	if ($.browser.msie && $.browser.version.substr(0,1)<7) {
		$('select').css('visibility', 'visible');
	}
}

window.disableGui = function () {
	if(typeof nd == 'function') {
		nd();
	}
	if ($.browser.msie && $.browser.version.substr(0,1)<7) {
		$('select').css('visibility', 'hidden');
	}
	$('#guidisable').css({'visibility': 'visible', 'display': 'block'});
}

window.registerbutton = function (pelid, pdisablefunc, penablefunc){
	gButtons[gButtons.length] = new Array(pelid, pdisablefunc, penablefunc);
}

window.disablebuttons = function (){
	for(let i=0; i<gButtons.length; i++){
		gButtons[i][1].call();
	}
	if(!doctype_transitional) $(':input').attr('disabled', true); //can cause problems in old doctypes...
	$('.ui-button').button('disable');
}

window.disablebutton = function (pelid){
	for(let i=0; i<gButtons.length; i++){
		if(gButtons[i][0] == pelid) gButtons[i][1].call();
	}
	$('#' + pelid).button('disable');
}

window.enablebutton = function (pelid){
	for(let i=0; i<gButtons.length; i++){
		if(gButtons[i][0] == pelid) gButtons[i][2].call();
	}
	$('#' + pelid).button('enable');
}

window.enablebuttons = function (){
	for(let i=0; i<gButtons.length; i++){
		gButtons[i][2].call();
	}
	if(!doctype_transitional) $(':input').attr('disabled', false); //can cause problems in old doctypes...
	$('.ui-button').button('enable');
}

window.decode_htmlspecialchars = function (pstring){

	const SpecialChars_Encoded = new Array('&amp;','&quot;','&#039;','&lt;','&gt;','&#92;');
	const SpecialChars_Decoded = new Array('&','"',"'",'<','>','\\');
	let i;
	let newstring = String(pstring);
	for(i=0;i<(SpecialChars_Encoded.length);i++){
		const tmpExpFind = new RegExp(SpecialChars_Encoded[i],'g');
		newstring = newstring.replace(tmpExpFind,SpecialChars_Decoded[i]);
	}
	return newstring;
}

let CSSTABLENAV_R_PREVCLASS;
let CSSTABLENAV_B_PREVCLASS;

window.CSSROVER = function (el){
	CSSTABLENAV_R_PREVCLASS = el.className;
	el.className = 'HIGHLIGHT';
}

window.CSSROUT = function (el){
	el.className = CSSTABLENAV_R_PREVCLASS;
}

window.CSSBOVER = function (el){
	el.style.background = '#88BBEE';
}

window.CSSBOUT = function (el){
	el.style.background = '#6699CC';
}

window.dtps_alertPrintArray = function (data,context,indent) {
	indent = (indent == null) ? false : indent;
	context = (context == null) ? '' : context;
	let i = 0;
	let notEmpty = false;

	const tab = '        ';
	const lineStart = indent ? tab : '';
	const dash = '------------';


	let outputBuffer = context + '\n';
	outputBuffer = outputBuffer + lineStart + dash + '\n';

	if (data.length > 0) {
		for(i;i<(data.length);i++) {
			if (data[i] instanceof Array) {

				outputBuffer = outputBuffer + lineStart + '[' + i + '] = ' + dtps_alertPrintArray(data[i],'subArray:',true);
				outputBuffer = outputBuffer + lineStart + tab + dash + '\n';
			} else {
				outputBuffer = outputBuffer + lineStart + '[' + i + '] = ' + data[i] + '\n';
			}
			notEmpty = true;
		}

	} else {
		outputBuffer = outputBuffer + lineStart + 'The array is empty\n';

	}

	if (!indent) {
		if(notEmpty)
			outputBuffer = outputBuffer + lineStart + dash + '\n';
		alert(outputBuffer);
		return true;
	} else {
		return outputBuffer;
	}
}

window.doChange = function (field) {
    let field_id = '';
    let $field;

    if (typeof(field) == "string") {
        field_id = field;
        $field = $("#" + field);
    } else {
        $field = $(field);
        if ($field.length > 0) {
            field_id = $field.attr('id');
        }
    }
    let $field_old = $("#" + field_id + '_old');

    if ($field_old.length && $field.length) {

        let formid = $field.closest("form").attr("id");

        if (formid != undefined) {
            $("#" + formid + "_changed_elements").val(function (index, value) {
                let id_arr = value.split(',');
                if (id_arr == undefined) id_arr = new Array();
                let field_index = jQuery.inArray(field_id, id_arr);
                if (field_index != -1) {
                    if (window[field_id + "_getValue"]() == $field_old.val()) {
                        return id_arr.slice(0, field_index).concat(id_arr.slice(field_index + 1)).join(',');
                    } else {
                        return value;
                    }
                } else if (window[field_id + "_getValue"]() == $field_old.val()) {
					return value;
                } else {
					return value + "," + field_id;
				}
            });
        }
        $field.toggleClass("dtps_status_failed", false).toggleClass("dtps_status_change", window[field_id + "_getValue"]() != $field_old.val());
    }
}

window.showHide = function (id) {
	let q = document.getElementById(id);
	if(q.style.display == 'block')
		q.style.display = 'none';
	else
		q.style.display = 'block';
}

/* jQuery generic functions...
 * ----------------------------------------------------------------------
 * openDialog()
 */

//UI Dialog functions...

window.openDialog = function (url, title, width, height, refresh, onComplete) {
	let original_width = width;
	title = typeof title != 'undefined' ? title : 'Loading...';
	height = typeof height != 'undefined' ? height : 'auto';

	if (!url) {
		return openDialogClientSide(title, original_width, height, refresh, onComplete);
	}

	url += '&ddepth='+(++jquery_dialog_depth);

    const restore_mouse_pointer = change_mouse_pointer_style_for_N_seconds('wait', 5);

    const $new_dialog = $("<div class='dtps_dialog'></div>")
	    .html("Loading...")
	    .dialog({
	    		modal: true,
	         autoOpen:false,
	         stack: true,
	         title: "Loading...",
	         close: function(ev, ui) {
	    			$(this).dialog("destroy").remove();
	    		},
	    		dragStart: function(event, ui) {
	    			$(this).parent().css('opacity', '.8');
	    		},
	    		dragStop: function(event, ui) {
	    			$(this).parent().css('opacity', '1');
	    		}
	    })
	    .attr('url', url)
	    .load(url, function() {
            restore_mouse_pointer();
			if (typeof onComplete === "function") {
				onComplete($new_dialog);
			} else if(typeof window[onComplete] === "function") {
				window[onComplete]();
			}
		});

	if (typeof refresh === 'function') {
		$new_dialog.on( "dialogclose", refresh);
	}


    return $new_dialog;
}

window.change_mouse_pointer_style_for_N_seconds = function (pointer_style, seconds) {
    pointer_style = pointer_style || 'wait';

    const $mouse_style = $('<style class="mouse_styling">* {cursor: ' + pointer_style + ';}</style>');
    $('body').append($mouse_style);

    const restore_mouse_pointer = function(){
        $mouse_style.remove();
    };

    let milliseconds = 1000 * (parseFloat(seconds) || 0);
	if (milliseconds > 0 ) {
    	setTimeout(restore_mouse_pointer, milliseconds);
	}

    return restore_mouse_pointer;
}

window.openDialogClientSide = function (title, width, height, refresh, onComplete) {
	width = width || 'auto';

	let $new_dialog = $('<div class="dtps_dialog" data-type="clientside"></div>')
    .dialog({
    		modal: true,
             autoOpen:false,
             stack: true,
             title: title,
             width: width,
             height: height,
             close: function(ev, ui) {
             		if (onComplete) {
             			onComplete();
             		}
                    $(this).dialog("destroy").remove();
                    if (refresh) {
                        if (typeof refresh == 'function') {
                            refresh();
                        } else {
                            reloadDialog();
                        }
                    }
                },
    		dragStart: function(event, ui) {
    			$(this).parent().css('opacity', '.8');
    		},
    		dragStop: function(event, ui) {
    			$(this).parent().css('opacity', '1');

				if ($(this).parent().offset().top < 0) {
					$(this).parent().offset({top: 0});
				}
    		}
    });

	// Fix for large dialogs jumping out of viewport on drag start
	if (window.chrome) {
		$new_dialog.parent().draggable('option', 'containment', 'body');
	}

	$new_dialog.center_me = center_dialog();


	const x =  Number(($(window).width() - width)/2);
	let y =  100;

	if($('body').find('.dtps_dialog').length > 1) {
		const $dialog_below = $('.dtps_dialog').slice(-2,-1);
		const xyCoordinates = $dialog_below.dialog('option','position');
		y = xyCoordinates[1] + 20;
	}

	if($new_dialog.attr('reload') != 1) {
		$new_dialog.dialog('option', 'position', [x,y]);
	}

	return $new_dialog.dialog('open');
}

window.center_dialog = function () {

	const window_width = $(document).width();

	return function() {
		const $dialog = $(this).closest('.ui-dialog');

		$dialog.css('left', '0px');
		const dialog_width = $dialog.width();
		const left = Math.max((window_width - dialog_width)/2, 10);
		$dialog.css('left', left + 'px');

	}
}

window.reloadDialog = function (redirect,overwrite_get_params) {
	if($('body').find('.dtps_dialog').length > 0) {
		const  $dialog = $('.dtps_dialog:last');
		if($dialog.data("type") == "clientside") {
			$dialog.unmask(); // laten staan, want wie weet nog in gebruik?
			hideMask(undefined, undefined, $dialog)
			return;
		}
		if(redirect) $dialog.attr('url', redirect);
		let urlparts = $dialog.attr('url').split('&');
		let ddepthset = false;
		for(let i=0; i<urlparts.length; i++) {
			if(urlparts[i].substring(0,6)=='ddepth') {
				urlparts[i] = 'ddepth='+(++jquery_dialog_depth);
				$dialog.attr('url', urlparts.join('&'));
				ddepthset = true;
				break;
			}
		}
		if(!ddepthset) {
			$dialog.attr('url', $dialog.attr('url')+'&ddepth='+(++jquery_dialog_depth));
		}
		if(overwrite_get_params) {
			urlparts = $dialog.attr('url').split('&');
			let params = overwrite_get_params.split('&');
			let paramset = false;
			for(let i=0; i<params.length; i++) {
				paramset = false;
				if(params[i].indexOf('=')>0) {
					for(let j=0; j<urlparts.length; j++) {
						if(urlparts[j].substring(0,params[i].indexOf('=')+1) == params[i].substring(0,params[i].indexOf('=')+1)) {
							urlparts[j] = params[i];
							paramset = true;
						}
					}
					if(!paramset) {
						urlparts.push(params[i]);
					}
				}
			}
			$dialog.attr('url',urlparts.join('&'));
		}
		// Check if a tab is selected
		let tab_index = 0;
		if($dialog.find('ul.ui-tabs-nav').length) {
			tab_index = $dialog.find('ul.ui-tabs-nav li.ui-tabs-selected').first().index();
		}
		$dialog.attr('reload', 1);
		$dialog.find('*').css('cursor', 'wait');
		$dialog.css('opacity', .67);
		$dialog.load($dialog.attr('url'), null, function() {
			$dialog.find('*').css('cursor', '');
			$dialog.css('opacity', 1);
			if (tab_index > 0) {
				$dialog.find('ul.ui-tabs-nav li:nth-child(' + (parseInt(tab_index) + 1) + ') > a').first().click();
			}
		});
	} else {
		reloadPage(redirect,overwrite_get_params);
	}
}

window.displayError = function (msg) {
	if($('body').find('.dtps_dialog').length > 0) {
		errorDialog(msg);
	} else {
		errorPage(msg);
	}
}

window.reloadPage = function (url, overwrite_get_params) {
    if (overwrite_get_params) {
        if (!url) {
            url = document.URL;
        }

        let search_string = url.indexOf('?') >= 0 ? url.substring(url.indexOf('?') + 1) : '';
        if (search_string.charAt(search_string.length - 1) == '#') {
            search_string = search_string.substring(0, search_string.length - 1);
        }

        let search_object = search_string_to_object(search_string);
        const replace_with = search_string_to_object(overwrite_get_params);
        const request = $.extend(search_object, replace_with);

        const path = url.substring(0, url.indexOf('?'));
        const new_search_string = request ? '?' + object_to_search_string(request) : '';

        url = path + new_search_string;
    }
    if (url)
        document.location = url;
    else
        window.location.reload();
}

window.search_string_to_object = function (search_string) {
    const object = {};

    if (search_string) {
        let array = search_string.split('&');
        $.each(array, function (index, item) {
            let key_value_pair = item.split('=');
            object[key_value_pair[0]] = key_value_pair[1] || '';
        });
    }

    return object;
}

window.object_to_search_string = function (object) {
    let array = [];

    $.each(object, function (key, value) {
        array.push(key + '=' + value);
    });

    return array.join('&');
}

window.closeDialog = function () {
	$('.dtps_dialog:last').dialog('close');
}

window.clearUiWidgetsDialog = function () {
	errorDialog();
	infoDialog();
}

window.errorPage = function (msg) {
	$("#msgDiv").clone().removeAttr("id").addClass("ui-state-error").children(".dtps_page_message_content").html(msg).parent().prependTo('#msgContainer').show("blind");
}

window.infoPage = function (msg) {
	$("#msgDiv").clone().removeAttr("id").addClass("ui-state-highlight").children(".dtps_page_message_content").html(msg).parent().prependTo('#msgContainer').show("blind");
}

window.errorDialog = function (msg) {
	UiUpdateWidgetState(msg, 'error', '.dtps_dialog:last ');
}

window.infoDialog = function (msg) {
	UiUpdateWidgetState(msg, 'highlight', '.dtps_dialog:last ');
}

window.UiUpdateWidgetState = function (msg, type, context) {

	if(!context) context = '';
	if(!msg || msg == 'null') {
		//Reset the errors...
		$(context + '.ui-widget .ui-state-' + type + ' p .msg').html('');
		$(context + '.dtps_' + type).css('display', 'none');
		return true;
	}
	const msg_old = $(context + '.ui-widget .ui-state-' + type + ' p .msg').html();
	msg = prepareMessage(msg, msg_old);

	$(context + '.ui-widget .ui-state-' + type + ' p .msg').html(msg);
	$(context + '.dtps_' + type).css('display', 'block');
}

window.prepareMessage = function (msg, msg_old) {
	if(msg_old) {
		msg = msg_old + ', ' + msg;
		if(msg.substr(0,2) == ', ') msg = msg.substr(2);
	}
	return msg;
}

//DataTables.net extra dtps functions...

window.fnSetKey = function ( aoData, sKey, mValue ) {
	for ( let i=0, iLen=aoData.length ; i<iLen ; i++ ) {
		if ( aoData[i].name == sKey ) {
			aoData[i].value = mValue;
		}
	}
}

window.fnGetKey = function ( aoData, sKey ) {
	for ( let i=0, iLen=aoData.length ; i<iLen ; i++ ) {
		if ( aoData[i].name == sKey ) {
			return aoData[i].value;
		}
	}
	return null;
}

window.fnFillSearchFields = function (oTable, divId) {
	let oSettings = oTable.fnSettings();
	$("#" + divId + " tfoot input").each(function(i) {
		if(oSettings.aoPreSearchCols[i]['sSearch']!='') {
			$(this).val(oSettings.aoPreSearchCols[i]['sSearch']);
		}
	});
	$("#" + divId + " tfoot select, ").each(function(i) {
		if(oSettings.aoPreSearchCols[i]['sSearch']!='') {
			$(this).val(oSettings.aoPreSearchCols[i]['sSearch']);
		}
	});
	if(oSettings.oPreviousSearch['sSearch']!='') {
		$("#" + divId + " .search_field").val(oSettings.oPreviousSearch['sSearch']);
	}
}

window.isNumber = function (n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

window.dtps_store_user_setting = function (name, value, callback ) {
	if (!name) return;

	const dbaction = "DTPS_UUDA-" + name + "-"+ (value||'');

	dtps_db_action(dbaction, callback);
}

window.dtps_db_action = function (dbaction, callback) {
	if (!dbaction) return;

	if (typeof callback != typeof Function ) {
		callback = function(){};
	}

	$.post("?action=xhr&saction=die", { dbactionstring: dbaction, ajax: 1 }, callback);
}

window.block_doubleclick_if_detected = function  () {
    if (window.just_clicked) return true;

    window.just_clicked = true;
    setTimeout(function() {
        window.just_clicked = false;
    }, 400);

    return false;
}

// NB: gebruik liever showMask & hideMask dan page_mask en page_unmask.
window.page_mask = function (text, remove_spinner) {
	let mask = $('#page_mask');
	if (!mask.length) {
		mask = $('<div id="page_mask" class="modal-busy"><div class="loadertext"></div><span class="spinner large"></span></div>').appendTo($('body'));
	}

	mask.find('.loadertext').html(text);

	if (remove_spinner) {
		mask.find('.spinner').hide();
	} else {
		mask.find('.spinner').show();
	}
}

window.page_unmask = function () {
	$('#page_mask').remove();
}

window.showMask = function (maskOptions) {

	let id = null;
	let content;
	if (maskOptions.element) {
		content = maskOptions.element
	} else if (maskOptions.id) {
		id = maskOptions.id;
		if (document.getElementById(id)){
			content = document.getElementById(id)
		}
	}
	if (maskOptions.parent) {
		content = content.parentNode
	}
	let text = '';
	if (maskOptions.text) {
		text = maskOptions.text;
	}
	let loader = document.createElement('div');
	loader.innerHTML = '<div class="loadertext ">' + text + '</div>' 
	loader.setAttribute('class', 'dtps_loader spinner ' + maskOptions.size);

	if (content?.childNodes?.[0]) {
		content.insertBefore(loader, content.childNodes[0]);
	} else if (content?.[0]){
		content[0].insertBefore(loader, content[0].childNodes[0]);
	} else {
		document.getElementById('dtps_page').insertBefore(loader, document.getElementById('dtps_page').childNodes[0])
	}
}

window.hideMask = function (id, parent, element) {
	if (typeof parent === 'undefined'){
		parent = false;
	}
	if (typeof element === 'undefined'){
		element = null;
	}
	let content = ''
	if (id != null){
		content = document.getElementById(id);
	} else if (element != null){
		content = element[0];
	}
	if (parent && content){
		content = content.parentNode;
	}

	let loader;
	if (content){
		loader = content.getElementsByClassName('dtps_loader')[0];
	} else {
		loader = document.getElementById('dtps_page').getElementsByClassName('dtps_loader')[0];
	}

	if (loader){
		loader.parentNode.removeChild(loader);
	}	
}

window.os_niveau_select_item = function (e, data) {
	request_new_os_tree_items(data.rslt.obj.attr("id").substr(8));
}


window.dtps_breadcrumb_click = function (){
	request_new_os_tree_items($(this).data('os_niveau_id'));
}

window.request_new_os_tree_items = function (parent_id) {
	$("#treeview_container").jstree("deselect_all");
	$("#dbactionstring").val("OS_PLUG_OU_U-" + parent_id);
	$("#treeview_form").submit();
}

window.dtps_breadcrumbs_browser = function  () {
	const $this = $(this);
	let $children_container = $this.find(".breadcrumb_children");

	if ($children_container.length == 0) {
	
		$children_container = $("<div class='breadcrumb_children'></div>");
	    $(this).append($children_container);
		$.get('', {
			action:'plugin',
			plaction:'get_tree_data',
			plug:'os_niveau',
			id:$this.data('os_niveau_id')
		}, function(response){
			const $list = $('<ul style="margin: ' + $this.height() + 'px ' + $this.width() +'px;">' + response.map(function(os_niveau){
				return '<li class="dtps_breadcrumb_child" data-os_niveau_id="' + os_niveau.attr.id.substr(8) + '">' + os_niveau.data + "</li>"
			}).join("\n") + '</ul>');
			
			$children_container.on('mouseleave', function(){
				$children_container.hide();
			});

			$children_container.html($list);
		});	
	}

	$children_container.show();
}

window.FilterInputString = function (inputstring) {
	let strnew;
	const tmpExpEscape = /@/g;
	const tmpExpMainDelimit = /&/g
	const tmpExpSubDelimit = /;/g
	const tmpExpFieldDelimit = /-/g
	strnew = inputstring.replace(tmpExpEscape,'@@');
	strnew = strnew.replace(tmpExpMainDelimit,'@&');
	strnew = strnew.replace(tmpExpSubDelimit,'@;');
	strnew = strnew.replace(tmpExpFieldDelimit,'@-');
	return strnew;
}

window.dtpsDatePicker = function (element, customOptions){
	// element can be jquery element of the form: $('input[name="mededeling-datum"]')
	// element kan ook een id zijn. 
	// customOptions can be anything from the options list of https://flatpickr.js.org/options/ V4

	// disabled: geef het oorspronkelijke input veld 'disabled' als html waarde mee, dan neemt flatpickr dit over. 

	let options = {
		altInput: true,
		altFormat: "F j, Y H:i",
		dateFormat: "Y-m-d H:i",
		'locale': 'nl',
		time_24hr: true,
		shorthandCurrentMonth: false,
		allowInput: true,
		onClose: function(dates, currentDateString, pickerConfig){
			pickerConfig.setDate(pickerConfig.altInput.value, true, pickerConfig.config.altFormat);
		}
	};

	for (let option in customOptions) {
		options[option] = customOptions[option];
	}
	flatpickr(element, options);
}
